import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeContext } from '../../context/ThemeContext';
import { DefaultTokenContext } from '../../context/DefaultTokenContext';
import { SetupContext } from '../../context/SetupContext';
import { NetworkContext } from '../../context/NetworkContext';
import useSecureStorage from '../../hooks/useSecureStorage';

import 'react-datepicker/dist/react-datepicker.css'; // DatePicker 스타일 추가

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { checkSelectActiveTab, checkUnlock, checkUnlockPincode, RootState } from '../../store';

import PinCodeScreen from '../Authentication/PinCodeScreen';

import WebApp from '@twa-dev/sdk'

const UnlockScreen: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	const networkContext = useContext(NetworkContext);
	const { forceTokenDataUpdate } = useContext(DefaultTokenContext)
	const { forceEventUpdate } = useContext(SetupContext)
	const { getBlockChain } = useSecureStorage()

	let location = useLocation();
	let navigate = useNavigate();
	const { t } = useTranslation();
	let dispatch = useDispatch();

	const [showPinCodeAuth, setShowPinCodeAuth] = useState(true)
	const [fingerprintEnabled, setFingerprintEnabled] = useState(false)

	useEffect(() => {
		// 백버튼 초기화
		const initializeTgBack = async () => {
			const fullPath = location.pathname + location.hash
			console.log(`텔레그램 백버튼 초기화 : ${fullPath}`)

			const platform = WebApp.platform
			if (fullPath === '/UnlockScreen') {
				// UnlockScreen 들어오면 텔레그램 백 버튼 숨김 (닫기 버튼으로 변경됨)
				if('android' === platform || 
					'android_x' === platform || 
					'ios' === WebApp.platform || 
					'tdesktop' === WebApp.platform ||
					'macos' === WebApp.platform) {
					WebApp.BackButton.hide();
				}
			} else {
				// 텔레그램 미니앱의 백 버튼 표시
				if('android' === platform || 
					'android_x' === platform || 
					'ios' === WebApp.platform || 
					'tdesktop' === WebApp.platform ||
					'macos' === WebApp.platform) {
					WebApp.BackButton.show();
				}
			}
		}
		
		// 언락화면 표시 초기화
		const initUnlock = async () => {
			const useFingerprintEnabled = await localStorage.getItem('fingerprintEnabled')
			
			// unlockpincode 값 초기화
			dispatch(checkUnlockPincode(''))

			// 마지막 선택한 코인/토큰 탭 초기화
			dispatch(checkSelectActiveTab(''))

			if('true' === useFingerprintEnabled) {
				setFingerprintEnabled(true)
			}

			setShowPinCodeAuth(true)
		}

		const initNetowrk = async () => {
			const selNetwork = await getBlockChain();
			console.log(`UnlockScreen initNetowrk 네트워크 : ${selNetwork}`)
      		// NetworkContext의 setSelectedNetwork 호출해서 교체
			await networkContext.setSelectedNetwork(selNetwork.toLowerCase());

			await forceTokenDataUpdate()
			
			await forceEventUpdate()
		}

		initializeTgBack()
		initNetowrk()
		initUnlock()
	}, [location])
	
	const handlePinCodeintAuthSuccess = (pin: string) => {
		setShowPinCodeAuth(false)
		
		dispatch(checkUnlock(true))
		
		// redux에 unlockpincode 저장
		// dispatch(checkUnlockPincode(pin))

		setTimeout(() => {
			// 홈화면으로 이동
			navigate(`/BalanceScreen`)
		}, 500)
	}

	const styles = {
		container: {
			padding: "0px 0px 0",
		} as React.CSSProperties,
		modalBackground: {
			display: "flex",
			justifyContent: 'center',
			alignItems: 'center',
			width: "100%",
			height: "100%",
			padding: "0px 0px 0px 0px",
		} as React.CSSProperties,
		forgotPassword: {
			display: "flex",
			justifyContent: 'center',
			alignItems: 'center',
			width: "100%",
			height: "55px",
		} as React.CSSProperties,
		title1: {
			fontSize: 24,
			textAlign: 'center',
		} as React.CSSProperties,
	}

	return (
		<div className='container' style={{ ...styles.container, backgroundColor: theme.background_normal }}>
			<div className='modalbackground' style={styles.modalBackground}>
				{/* {fingerprintEnabled ? (
					<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' ,color: 'white', fontWeight:"bold" }}>
						'FingerPrint UI'
					</div>
				) : (
					<PinCodeScreen onSuccess={handlePinCodeintAuthSuccess} unlock={true} />
				)} */}
				<PinCodeScreen onSuccess={handlePinCodeintAuthSuccess} unlock={true} />
			</div>
			<div className='forgotPassword' style={styles.forgotPassword}>
				<div
					style={{ color: 'gray', fontWeight:"bold" }}
					onClick={() => navigate(`/ResetWalletScreen`)}
				>
					{t('unlock_screen_message_01')}
				</div>
			</div>
		</div>
	)
}

export default UnlockScreen
